import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
export default class Ingredient extends ItemsV3Serializer {}